module.exports = __webpack_public_path__ + "static/media/2 6 tattoo arm sleeve odin fenrir viking dark realism.1280x2276.05c166a4.webp";